import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import editButton from '../../../assets/edit-button.svg';
import closeButton from '../../../assets/close-button.svg';
import DatePickerTimeZone from '../../../components/DatePickerTimeZone';

require('moment-timezone');

function BonusCell({ item, handleEdit, handleDelete }) {
  const [isEditing, setEditing] = useState(false);
  const [date, setDate] = useState(item?.executionTime);

  const handleDate = (date) => {
    const currentTimezone = moment.tz.guess();
    const dateCurrentTZ = moment.tz(date, currentTimezone);
    return dateCurrentTZ.format('MM-DD-yyyy hh:mm a');
  };

  const handleSave = () => {
    handleEdit(item.id, { scheduledAt: date });
    setEditing(!isEditing);
  };

  return (
    <tr>
      <td>{item.title}</td>
      <td>
        {isEditing ? (
          <DatePickerTimeZone onChange={(ddd) => setDate(ddd)} value={date} />
        ) : (
          handleDate(item?.executionTime)
        )}
      </td>
      <td>{item.userCount}</td>
      <td>{item.message.title}</td>
      {isEditing ? (
        <td className="center-align">
          <button className="button" onClick={() => handleSave()}>
            Save
          </button>
        </td>
      ) : (
        <td className="space-around">
          <img
            className="edit-icon"
            alt="edit-button"
            src={editButton}
            onClick={() => setEditing(!isEditing)}
          />
          <img
            className="edit-icon"
            alt="close-button"
            src={closeButton}
            onClick={() => handleDelete(item.id)}
          />
        </td>
      )}
    </tr>
  );
}

export default BonusCell;
